export const hubShiftsIntlIds = {
  hubShiftsList: {
    table: {
      cell: {
        header: {
          date: 'hubShiftsIntlIds.hubShiftsList.table.cell.header.date',
          shift: 'hubShiftsIntlIds.hubShiftsList.table.cell.header.shift',
          assignRider:
            'hubShiftsIntlIds.hubShiftsList.table.cell.header.assignRider',
        },

        body: {
          shift: 'hubShiftsIntlIds.hubShiftsList.table.cell.body.shift',
        },
      },
    },
  },

  assignRiderToHubShiftModal: {
    trigger: {
      openModalButton: {
        label:
          'hubShiftsIntlIds.assignRiderToHubShiftModal.trigger.openModalButton.label',
      },
    },
    header: {
      title: 'hubShiftsIntlIds.assignRiderToHubShiftModal.header.title',
      closeIconButton: {
        label:
          'hubShiftsIntlIds.assignRiderToHubShiftModal.header.closeIconButton.label',
      },
    },
    body: {
      description:
        'hubShiftsIntlIds.assignRiderToHubShiftModal.body.description',
      reviewBeforeConfirming:
        'hubShiftsIntlIds.assignRiderToHubShiftModal.body.reviewBeforeConfirming',
      selectRider: {
        placeholder:
          'hubShiftsIntlIds.assignRiderToHubShiftModal.body.selectRider.placeholder',
        label:
          'hubShiftsIntlIds.assignRiderToHubShiftModal.body.selectRider.label',
        noRidersAvailable: {
          label:
            'hubShiftsIntlIds.assignRiderToHubShiftModal.body.selectRider.noRidersAvailable.label',
        },
      },

      errors: {
        allSlotsTaken: {
          label:
            'hubShiftsIntlIds.assignRiderToHubShiftModal.body.errors.allSlotsTaken.label',
        },
        overlappingBooking: {
          label:
            'hubShiftsIntlIds.assignRiderToHubShiftModal.body.overlappingBooking.label',
        },
      },
    },
    footer: {
      cancelButton: {
        label:
          'hubShiftsIntlIds.assignRiderToHubShiftModal.footer.cancelButton.label',
      },
      confirmAndAssignButton: {
        label:
          'hubShiftsIntlIds.assignRiderToHubShiftModal.footer.confirmAndAssignButton.label',
      },
    },

    toasts: {
      onSuccess: {
        title:
          'hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onSuccess.title',
        description:
          'hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onSuccess.description',
      },
      onError: {
        title:
          'hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onError.title',
        description:
          'hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onError.description',
      },
    },
  },
};
